export const categories = [
  {
    key: "entertainment",
    label: "明星娱乐",
    icon: "ri-star-line",
    desc: "行程变动、片场见闻、合约纠纷等一手圈内线索。",
    count: 186,
  },
  {
    key: "industry",
    label: "行业内幕",
    icon: "ri-building-4-line",
    desc: "招聘话术、内部分工、隐性规则与职场真实运转方式。",
    count: 142,
  },
  {
    key: "consumer",
    label: "消费维权",
    icon: "ri-shield-check-line",
    desc: "退换货套路、会员陷阱、隐性收费与售后扯皮实录。",
    count: 231,
  },
  {
    key: "society",
    label: "社会热点",
    icon: "ri-fire-line",
    desc: "现场目击、公共事件后续、被忽略的细节与补充视角。",
    count: 118,
  },
  {
    key: "finance",
    label: "财经观察",
    icon: "ri-line-chart-line",
    desc: "项目资金流向、宣传话术、招商口径与数据出入。",
    count: 97,
  },
  {
    key: "tech",
    label: "科技数码",
    icon: "ri-smartphone-line",
    desc: "产品缺陷、参数缩水、供应链传闻与软件暗坑。",
    count: 76,
  },
];